import { useEffect, useState } from "react";
import { Offcanvas } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ESpinner from "components/others/Spinner";
import * as apiWarehouse from "api/apiWarehouses";
import OperationInfo from "./OperationInfo";

 
const OffOperationInfo = ({show, setShow}) => {

    const { t } = useTranslation(['Warehouses']);
    const [ operationInfo, setOperationInfo ] = useState(null);
 
    const fetchOperarion = async () => {
        
        const resOperation = await apiWarehouse.getOperationInfo(show);
        setOperationInfo(resOperation);
        console.log(resOperation)
    } 

    const handleHide = () =>{ 
        setShow(false);
        setTimeout(() => {
            setOperationInfo(null);
        }, 300);
    }

    useEffect(()=>{
        if (show) fetchOperarion();
            else handleHide();
    },[show])

    return (<>
     
        <Offcanvas 
            show={show!==false} 
            onHide={handleHide}
            placement="end">
            <Offcanvas.Header closeButton className="border-bottom">
                <Offcanvas.Title>{t('titleOperInfo')}</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="px-0 position-relative"> 
                {operationInfo
                    ? (<OperationInfo 
                            fetchOperarion={fetchOperarion}
                            operationInfo={operationInfo}/>)
                    : (<ESpinner/>)}
            </Offcanvas.Body>
        </Offcanvas>
        </>);
}

export default OffOperationInfo;